import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csoverload(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# overload tutorial For Beginners</title>
 <meta name="description" content="C# overload tutorial for beginners.overloading in c# method is the example of compile-time polymorphism and this is also known as a static polymorphism in c#. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,No of argument example in method overloading in C#,Static Polymorphism in C#,Method overloading in c# example,tutorial for begineers,C# overload,c# overload for,c sharp overload,Overload tutorial in C#" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-overloading" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Overload in C#</h1>
    <div className="first">
        <a href="/csharp-association">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-overriding">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">Overloading in c# method is the example of compile-time polymorphism and this is also known as a static polymorphism in c#.</p>
<h2 className="mt-4 mh2">Rules of overloading in the CSharp(C#) method:</h2>
<p className="mt-4 para">1, If you call two methods so both methods place inside the  same class<br/>
2, Two or multiple method names are same<br/>
3, Two or multiple method arguments are different means you change <br/>
</p>
<h4 className="mt-4">a, Sequence of argument<br/>
b, Numbers of argument<br/>
c, Type of argument<br/>
</h4>
<h2 className="mt-4 mh2">Method overloading in c# example:
</h2>



<h2 className="headings">Q-No of argument example in method overloading in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">overload</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">1 </span>
            <span className="qwerty-6">over</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">String</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-6">give one argument  </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">2</span>
            <span className="qwerty-6"> over</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">overload</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">overload </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-7">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">1 </span>
            <span className="qwerty-5">over </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<p className="mt-4 para">when we call over() method so on that time inside this method no argument passed so this method  call  no argument method</p>




<h2 className="headings">Q-Sequence of argument change in method overloading in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-2">, </span>
            <span className="qwerty-4">String</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-6">give 2 argument but first integer and second string</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">1 </span>
            <span className="qwerty-6">over</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">String</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-2">, </span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-6">give 2 argument but first string and the second integer</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">2</span>
            <span className="qwerty-6"> over</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-3">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">overload</span>
            <span className="qwerty-2"> o</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">new </span>
            <span className="qwerty-7">overload </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">25</span>
            <span className="qwerty-1">, </span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-2">Ram</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-6">check and call first string and second integer argument method</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">1 </span>
            <span className="qwerty-5">over </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Type of argument in method overloading in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">overload</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-6">give one argument but this is an integer</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">int</span>
            <span className="qwerty-6"> overload</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">String</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-6">give one argument but this is a string</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">string</span>
            <span className="qwerty-6"> overload</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-3">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">overload</span>
            <span className="qwerty-2"> o</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-4">new </span>
            <span className="qwerty-7">overload </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">Har-Har-</span>
            <span className="qwerty-6">Madadev</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">string </span>
            <span className="qwerty-5">overload </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-association">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-overriding">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>

    </div>
)

}
export default Csoverload;